export let FRENCH = {
    'navbar' : {
        'language': 'Langue',
        'link1' : 'Visualisation des PLD',
        'link2' : 'Détection des PLD',
        'link3' : 'Démonstration',
    },
    'animator' : {
        'CSVLoader' : 'Charger un fichier CSV',
        'JSONLoader' : 'Charger un fichier JSON',
        'upload_button' : 'Charger un fichier',
        'change_frame_rate' : 'modifier la fréquences des frames',
        'upload_link':{
            'message' : "vous pouvez charger un fichier en entrant son lien ci-dessous",
            'place_holder' : 'Entrer un lien ici',
            'load' : "charger"
        },
        'frame_rate': "Vitesse d'Animation"
    },
    'video' : {
        'detection_type':{
            videoDetection: "Détection à partir d'une vidéo",
            webcamDetection: 'Détection en temps réel'
        },
        'estimation_type':{
            global_motor_skills: 'Motricité Globale',
            fine_motor_skills: 'Motricité Fine',
            face_expression: 'Expression du visage',
            full_body: 'Corps entier'
        },
        'upload_button' : 'Charger Une Video',
        'estimate_pose_btn': {
            'ready' :  "Commencer l'Estimation",
            'running' : "En cours ... ",
        },
        'download_landmarks_csv':"Exporter les PLD (CSV)",
        'download_landmarks_json':"Exporter les PLD en format JSON",
        // 'download_mp4': "Exporter la vidéo + les PLD",
        'download_mp4_PLD': "Exporter les PLD",
        "acquisition_info":{
            'h':"Modifier les informations d'acquisition",
            'p':"Vous pouvez ajouter des informations d'acquisition dans la table ci-dessous. Ces informations seront sauvegardées en format JSON si vous exportez la vidéo.",
            'property':"Attribut",
            'info':"Information",
            'add':"Ajouter",
            'remove':"Supprimer",
            'btn':"Ajouter les infos d'acquisition",
            'save':'sauvegarder',
            'close':'fermer'
        },
        'download_metadata': 'Exporter les métadonnées'
    },
    'webcam':{
        'start_recording': "Commencer l'estimation",
        'stop_recording': "Arréter l'estimation",
    },
    'footer':{
        'sponsored' : ''
    },
    'main':{
        'p1':{
            'h':"A propos de l'application",
            'p':"Grâce à l'intelligence artificielle, le laboratoire XLIM a développé en collaboration avec le CeRCA un outil permettant de détecter en temps réel la position des articulations d'un acteur en mouvement à partir d'une vidéo MP4. L'outil permet également la visualisation et l'enregistrement de la représentation acquise ainsi que la récupération des coordonnées 2D de chaque articulation. Cet outil permet ainsi de créer de manière automatique des 'point-light display' (PLD, Johansson, 1973) c'est à dire des séquences animées de points représentant le mouvement des articulations principales du corps humain au cours d'une action."
        },
        'p2':{
            'h':'Visualisation des PLD',
            'p':"Cette section permet de visualiser une représentation PLD à partir d'un fichier CSV contenant des coordonnées X et Y représentant le déplacement de certains membres du corps."
        },
        'p3':{
            'h':'Detection des PLD',
            'p':"Cette section permet de construire un PLD, c'est-à-dire de détecter les principales articulations du corps en mouvement, à partir d'une vidéo MP4.",
            'm':"Ce site permet de visualiser le calcul de PLD à partir d'une vidéo sans utiliser de marqueur, cet outil fonctionne avec Firefox et Safari. Une application de bureau (disponible pour Windows) offre des fonctionnalités supplémentaires comme le traitement de vidéo par lot et des traitements de données plus aprofondis qui améliorent les détections (lien bientôt disponible)."
        },
        'p4':{
            'h':'Manuel Utilisateur'
        }
    }
}

export let ENGLISH = {
    'navbar' : {
        'language': 'Language',
        'link1' : 'PLD Visualization',
        'link2' : 'PLD Detection',
        'link3' : 'Demonstration',
    },
    'animator' : {
        'CSVLoader' : 'Upload CSV File',
        'JSONLoader' : 'Upload JSON file',
        'upload_button' : 'Upload File',
        'change_frame_rate' : 'Change Speed of Animation',
        'upload_link':{
            'message' : "You could upload a file by entering its' link below",
            'place_holder' : 'Enter Link',
            'load' : "Load"
        },
        'frame_rate': "Frame Rate"
    },
    'video' : {
        'detection_type':{
            videoDetection: 'Video Detection',
            webcamDetection: 'Webcam Detection'
        },
        'estimation_type':{
            global_motor_skills: 'Global Motor Skills',
            fine_motor_skills: 'Fine Motor Skills',
            face_expression: 'Face Expression',
            full_body: 'Full Body Detection'
        },
        'upload_button' : 'Upload Video',
        'estimate_pose_btn': {
            'ready' :  "Start Estimating",
            'running' : "Estimating ... ",
        },
        'download_landmarks_csv':"Download Landmarks as CSV",
        'download_landmarks_json':"Download Landmarks as JSON",
        // 'download_mp4': "Download Video + PLD",
        'download_mp4_PLD': "Download PLD",
        "acquisition_info":{
            'h':"Modify Acquisition informations",
            'p':"Please add acquisition information in the table below, this information will be saved when you export the results as JSON",
            'property':"Attribute",
            'info':"Information",
            'add':"Add",
            'remove':"Delete",
            'btn':"Add Acquisition Informations",
            'save':'save',
            'close':'close'
        },
        'download_metadata': 'Download Metadata'
    },
    'webcam':{
        'start_recording': 'Start Detecting',
        'stop_recording': 'Stop Detecting',
    },
    'footer':{
        'sponsored' : ''
    },
    'main':{
        'p1':{
		'h':'About the application',
            'p':'Thanks to artificial intelligence, the XLIM and CeRCA laboratories have developed a new application for the automatic, accurate detection and estimation of human body limbs from MP4 videos containing human movement. This tool enables both the recording and visualization of the generated representations, as well as the loading of computed 2D coordinates for each limb. The application automatically generates "point-light displays" (PLDs; Johansson, 1973), i.e., animated sequences of points that represent the motion of the main limbs of the human body during an action.'
        },
        'p2':{
	    'h':'PLD Visualization',
            'p':"This section allows you to visualize a PLD representation from a file in CSV containing X and Y coordinates that represent the displacement of certain body's limbs."
        },
        'p3':{
            'h':'PLD Detection',
            'p':'This section allows for the estimation of PLD, i.e., the detection of the primary moving limbs, from an MP4 video.',
	        'm':'This website provides a preview of PLD generation from video without the use of markers, available with Firefox and Safari. A windows desktop application offers additional features such as batch video processing and post-processing to enhance rendering (available soon).'
        },
        'p4':{
            'h':'User Manual'
        }
    }
}
